export const RECEIVE_ADMIN_USER_INFO = 'receive_admin_user_info' //保存后台用户信息

export const CLEAR_ADMIN_USER_INFO = 'clear_admin_user_info' //清除后台用户信息

export const UPDATE_ADMIN_TOKEN = 'update_admin_token' //更新后台token

// 添加 WEB_TOKEN 相关的常量定义
export const UPDATE_WEB_TOKEN = 'update_web_token' // 更新web端token
export const CLEAR_WEB_TOKEN = 'clear_web_token' // 清除web端token